import type { MutationResult } from '../../api/contract';
import { createRepositoryToken } from '../../data/RepositoryProvider';
import type { PageResult } from '../../shared/data/types';
import type {
  AdminUserDetail,
  AdminUserListQuery,
  AdminUserSummary,
  ChangeAdminAccessInput,
  ChangeAdminStatusInput,
  InviteAdminUserInput,
  PermissionDefinition,
  PermissionProfile,
  PermissionProfileInput,
  PermissionProfileListQuery,
  StatusReasonInput,
  UpdateAdminUserInput,
  UpdatePermissionProfileInput,
} from './types';

export interface AdminUsersRepository {
  listUsers(query: AdminUserListQuery, signal: AbortSignal): Promise<PageResult<AdminUserSummary>>;
  getUser(userId: string, signal: AbortSignal): Promise<AdminUserDetail>;
  inviteUser(input: InviteAdminUserInput): Promise<MutationResult<AdminUserDetail>>;
  updateUser(userId: string, input: UpdateAdminUserInput): Promise<MutationResult<AdminUserDetail>>;
  changeAccess(
    userId: string,
    input: ChangeAdminAccessInput,
  ): Promise<MutationResult<AdminUserDetail>>;
  changeStatus(
    userId: string,
    input: ChangeAdminStatusInput,
  ): Promise<MutationResult<AdminUserDetail>>;
  listPermissions(signal: AbortSignal): Promise<readonly PermissionDefinition[]>;
  listProfiles(
    query: PermissionProfileListQuery,
    signal: AbortSignal,
  ): Promise<PageResult<PermissionProfile>>;
  getProfile(profileId: string, signal: AbortSignal): Promise<PermissionProfile>;
  createProfile(input: PermissionProfileInput): Promise<MutationResult<PermissionProfile>>;
  updateProfile(
    profileId: string,
    input: UpdatePermissionProfileInput,
  ): Promise<MutationResult<PermissionProfile>>;
  changeProfileStatus(
    profileId: string,
    input: StatusReasonInput,
  ): Promise<MutationResult<PermissionProfile>>;
}

export const adminUsersRepositoryToken = createRepositoryToken<AdminUsersRepository>('adminUsers');

export const defaultAdminUserListQuery = Object.freeze<AdminUserListQuery>({
  page: 1,
  pageSize: 25,
  sort: 'updatedAt',
  order: 'desc',
  filters: {
    role: '',
    status: '',
    partnerId: '',
    agentId: '',
    permissionProfileId: '',
    username: '',
    email: '',
  },
});

export const defaultPermissionProfileListQuery = Object.freeze<PermissionProfileListQuery>({
  page: 1,
  pageSize: 25,
  sort: 'updatedAt',
  order: 'desc',
  filters: { partnerId: '', agentId: '', status: '', name: '' },
});
